import { Instance } from 'mobx-state-tree'
import { MembershipTypeModelBase } from './MembershipTypeModel.base'

/* The TypeScript type of an instance of MembershipTypeModel */
export interface MembershipTypeModelType extends Instance<typeof MembershipTypeModel.Type> {}

/* A graphql query fragment builders for MembershipTypeModel */
export {
  selectFromMembershipType,
  membershipTypeModelPrimitives,
  MembershipTypeModelSelector
} from './MembershipTypeModel.base'

/**
 * MembershipTypeModel
 */
export const MembershipTypeModel = MembershipTypeModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
